import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React, { FC } from "react";
import { useDebounce } from "use-debounce";

export type ReloadComponentProps = {
  loading: boolean;
  onReload: () => void;
  delay?: number;
};

export const Reload: FC<ReloadComponentProps> = ({ loading, delay, onReload }) => {
  const [loadingValue] = useDebounce(loading, delay ?? 0);

  return (
    <Button
      disabled={loadingValue}
      size="small"
      icon={<ReloadOutlined onClick={onReload} spin={loadingValue} />}
    ></Button>
  );
};
